let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lbcy9")).then(() => parcelRequire('9DM6I'));